export default __webpack_public_path__ + "static/media/AllenVDam.a59f24a6.png";